import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";

import { api } from "../../../utils/Api";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useParams } from "react-router-dom";

const animatedComponents = makeAnimated();

let myModal: any;

export default function ModalChoosing(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [org_save_data, SetOrgSaveData] = useState({});
  const [save_data, SetSaveData] = useState({});
  const [id_value, SetIdValue] = useState(useParams());
  const [shared_data, SetSharedData] = useState({});
  const [edit_value, SetEditValue] = useState(false);
  const [work_hour, SetWorkHour] = useState("");

  useEffect(() => {
    console.log("ModalChoosing On mount :", props);
    let myModal1: any = document.getElementById("ChoosingModal");
    myModal1.addEventListener("hidden.bs.modal", function (event: any) {
      console.log("event :", event);
      SetEditValue(false);
      SetSharedData({});
      SetWorkHour("");
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.data.open) {
      console.log("ModalChoosing On Open :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("ChoosingModal"),
        {}
      );
      myModal.show();
      if (props.data.to == "assign") {
        get_init();
      }
      if (props.data.to == "view") {
        SetWorkHour(props.data.task_data.max_working_hours);
        get_data();
      }
    }
  }, [props.data.open]);

  async function get_data() {
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        id: props.data.task_data.id,
      },
    };
    let response = await api("/editortask/view_shared", pass_data);
    console.log("view_shared response :", response);
    let share_value = response.response.data;
    SetSaveData(share_value);
    SetOrgSaveData(share_value);
    Object.keys(share_value).map((key: any, index: any) => {
      share_value[key].map((ele: any, ele_index: any) => {
        if (ele.checked) {
          SetSharedData((s_prevValue: any) => {
            if (s_prevValue.hasOwnProperty(key)) {
              s_prevValue[key].push(ele.id);
            } else {
              let save_value = [];
              save_value.push(ele.id);
              s_prevValue[key] = save_value;
            }
            return { ...s_prevValue };
          });
        }
      });
    });
  }

  async function get_init() {
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
    };
    if (props.data.type == "service") {
      pass_data.get.service_task_id = props.data.task_data.id;
    } else {
      pass_data.get.rework_task_id = props.data.task_data.id;
    }

    let response = await api("/editortask/assign_init", pass_data);
    console.log("response :", response);
    if (Object.keys(response.response.data).length > 0) {
      SetSaveData(response.response.data);
      SetOrgSaveData(response.response.data);
    } else {
      console.log("Auto Assign");
    }
  }

  function title_generate(title: any) {
    let replaced_data = title.replace("_", " ");
    var splitStr = replaced_data.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }

  async function assign_task() {
    let emp_data = props.data.emp_data;
    let task_data = props.data.task_data;
    console.log("emp data :", emp_data);
    console.log("task data :", task_data);
    let all_services: any = [];

    props.data.assigned_services.map((ele: any, index: any) => {
      console.log("assign_task all service ele :", ele);
      if (ele.hasOwnProperty("order_rework_id")) {
        console.log("rework id :", ele.order_rework_id);
        let value = {};

        value.rework_id = ele.order_rework_id;
        all_services.push(value);
      } else {
        console.log("id :", ele.service_task_id);
        let value = {};

        if (ele.hasOwnProperty("service_task_id")) {
          value.id = ele.service_task_id;
        } else {
          value.id = ele.id;
        }
        all_services.push(value);
      }
    });

    console.log("all_services :", all_services);
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        sp_id: emp_data.id,
        all_tasks: all_services,
        shared: shared_data,
        working_hours: work_hour,
      },
    };

    if (props.data.type == "service") {
      pass_data.post.service_task_id = props.data.task_data.id;
    } else {
      pass_data.post.rework_task_id = props.data.task_data.id;
    }

    if (props.data.selected_filter.name == "service") {
      pass_data.get.service_id = props.data.selected_filter.id;
    } else if (props.data.selected_filter.name == "task") {
      pass_data.get.task_id = props.data.selected_filter.id;
    }
    console.log("assign_task pass_data :", pass_data);

    let response = await api("/editortask/assign", pass_data);
    console.log("editortask assign Response :", response);
    if (response.response.hasOwnProperty("status")) {
      if (response.response.status == "success") {
        let item: any = close_data;
        item.action = "save";
        item.unassigned_services = response.response.unassigned_services;
        item.unassigned_reworks = response.response.unassigned_reworks;
        item.services = response.response.services;
        item.service_providers = response.response.service_providers;
        SetCloseData(item);
        SetSaveData({});
        myModal.hide();
      }
    }
  }

  async function update_shared() {
    console.log("update_shared shared_data :", shared_data);
    console.log("update_shared save_data :", save_data);
    let pass_data: any = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        id: props.data.task_data.id,
      },
      post: {
        data: save_data,
        duration: work_hour,
      },
    };
    console.log("pass_data :", pass_data);
    let response = await api("/editortask/update_shared", pass_data);
    console.log("update_shared Response :", response);
    if (response.response.hasOwnProperty("status")) {
      if (response.response.status == "success") {
        let share_value = response.response.data;
        SetSaveData(share_value);
        SetOrgSaveData(share_value);
        SetEditValue(false);

        Object.keys(share_value).map((key: any, index: any) => {
          share_value[key].map((ele: any, ele_index: any) => {
            if (ele.checked) {
              SetSharedData((s_prevValue: any) => {
                if (s_prevValue.hasOwnProperty(key)) {
                  s_prevValue[key].push(ele.id);
                } else {
                  let save_value = [];
                  save_value.push(ele.id);
                  s_prevValue[key] = save_value;
                }
                return { ...s_prevValue };
              });
            }
          });
        });
      }
    }
  }

  return (
    <div
      className="modal fade"
      id="ChoosingModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              {/* <div
                className="cursor pe-4"
                onClick={() => {
                  console.log("Back");
                }}
              ></div> */}
              {props.data.to == "assign" ? (
                <h5 className="  modal-title" id="ModalLabel">
                  Share Details With Editor
                </h5>
              ) : null}
              {props.data.to == "view" && !edit_value ? (
                <div>
                  <h5 className="  modal-title" id="ModalLabel">
                    View Shared
                  </h5>
                </div>
              ) : null}

              {edit_value ? (
                <div>
                  {/* <i
                    className="fas fa-arrow-left"
                    onClick={() => {
                      SetEditValue(false);
                      SetSaveData(org_save_data);
                    }}
                  ></i> */}
                  <h5 className="  modal-title" id="ModalLabel">
                    Edit Shared
                  </h5>
                </div>
              ) : null}
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>

          <div className="modal-body">
            <div className="d-flex">
              <nav className="pt-1 sticky-tabs">
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  {Object.keys(save_data).map((key: any, index: any) => (
                    <div
                      className={
                        index == "0"
                          ? "nav-link cursor active"
                          : "nav-link cursor"
                      }
                      id={key + "-tab"}
                      data-bs-toggle="tab"
                      data-bs-target={"#" + key}
                      role="tab"
                      aria-controls={key}
                      aria-selected={index == "0" ? "true" : "false"}
                      key={index}
                    >
                      {title_generate(key)}
                    </div>
                  ))}
                  <div
                    className={
                      Object.keys(save_data).length > 0
                        ? "nav-link cursor"
                        : "nav-link cursor active"
                    }
                    id="work-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#work"
                    role="tab"
                    aria-controls="work"
                    aria-selected={
                      Object.keys(save_data).length > 0 ? "false" : "true"
                    }
                  >
                    Work Hours
                  </div>
                </div>
              </nav>
              {props.data.to == "view" && !edit_value ? (
                <div className="ms-auto">
                  <button
                    onClick={() => {
                      SetEditValue(true);
                    }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/edit3-1.svg")}
                      className=""
                    />
                    Edit
                  </button>
                </div>
              ) : null}
            </div>
            <div
              className="tab-content mt-3 px-3 scroll-height"
              id="nav-tabContent"
            >
              {/* {Object.keys(save_data).length > 0 ? ( */}
              {Object.keys(save_data).map((key: any, index: any) => (
                <div
                  className={
                    index == "0"
                      ? "tab-pane fade show active"
                      : "tab-pane fade show"
                  }
                  id={key}
                  role="tabpanel"
                  aria-labelledby={key + "-tab"}
                  key={index}
                >
                  <div className="mt-3">
                    <div>
                      {save_data[key].map((ele: any, ele_index: any) => (
                        <div key={ele_index} className="mt-3 border-bottom">
                          <div className="d-flex pb-2">
                            <input
                              type="checkbox"
                              checked={ele.checked}
                              disabled={
                                props.data.to == "view"
                                  ? edit_value
                                    ? false
                                    : true
                                  : false
                              }
                              onChange={() => {
                                SetSaveData((prevValue: any) => {
                                  let value =
                                    !prevValue[key][ele_index].checked;
                                  prevValue[key][ele_index].checked = value;
                                  if (value) {
                                    SetSharedData((s_prevValue: any) => {
                                      if (s_prevValue.hasOwnProperty(key)) {
                                        s_prevValue[key].push(ele.id);
                                      } else {
                                        let save_value = [];
                                        save_value.push(ele.id);
                                        s_prevValue[key] = save_value;
                                      }
                                      return { ...s_prevValue };
                                    });
                                  } else {
                                    //   remove id
                                    console.log("remove id");
                                    SetSharedData((s_prevValue: any) => {
                                      if (s_prevValue.hasOwnProperty(key)) {
                                        let array_value = s_prevValue[key];
                                        console.log(array_value);
                                        let splice_index = array_value.indexOf(
                                          ele.id
                                        );
                                        if (splice_index !== -1) {
                                          console.log("array_value found");
                                          array_value.splice(splice_index, 1);
                                        } else {
                                          console.log("array_value not found");
                                        }
                                        s_prevValue[key] = array_value;
                                      }
                                      return { ...s_prevValue };
                                    });
                                  }
                                  return { ...prevValue };
                                });
                              }}
                            />{" "}
                            {/* <label className="ps-2 text-dark fw-600">
                                <b>{ele.created_user}</b>
                              </label>
                              <div className="ms-auto">
                                <p className="v-small mb-0 fw-600">
                                  <b>{ele.created_at}</b>
                                </p>
                              </div> */}
                            {Object.keys(ele).map((title_key, title_index) =>
                              title_key != "id" &&
                              title_key != "checked" &&
                              title_key != "created_at" &&
                              title_key != "created_user" &&
                              title_key != "created_username" &&
                              title_key != "profile_picture" ? (
                                <p
                                  key={title_index}
                                  className="mb-2 text-gray ms-2"
                                >
                                  {title_generate(title_key)} : {ele[title_key]}
                                </p>
                              ) : null
                            )}
                          </div>

                          {/* <p>Created checked :{ele.checked ? "true" : "false"}</p> */}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
              {/* ) : (
                <div>There is no data to share</div>
              )} */}
              <div
                className={
                  Object.keys(save_data).length > 0
                    ? "tab-pane fade show"
                    : "tab-pane fade show active"
                }
                id="work"
                role="tabpanel"
                aria-labelledby="work-tab"
              >
                <div className="mt-4">
                  <label className="form-label text-dark fs-6 fw-600">
                    Working Hours
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={work_hour}
                    disabled={
                      props.data.to == "view"
                        ? edit_value
                          ? false
                          : true
                        : false
                    }
                    onChange={(e) => {
                      console.log("work_hour", e.target.value);
                      SetWorkHour(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                if (edit_value) {
                  SetEditValue(false);
                } else {
                  let item = close_data;
                  item.action = "close";
                  SetCloseData(item);
                  myModal.hide();
                }
              }}
            >
              Cancel
            </button>
            {props.data.to == "assign" ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={() => {
                  console.log("Assign");
                  console.log("Assign shared :", shared_data);
                  console.log("Assign save :", save_data);
                  assign_task();
                }}
              >
                Assign
              </button>
            ) : edit_value ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={() => {
                  update_shared();
                }}
              >
                Update
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
